import Breadcrumbs from '~/components/Breadcrumbs';
import TransformedHtml from '~/components/Editor';
import PostPaddingContainer from '~/components/Layout/PostPaddingContainer';

import type { Admin } from '~/interfaces/admin';
import type { Post } from '~/interfaces/post';
import type { Subscription } from '~/interfaces/subscriptions';

import FloatingActions from '../pages/FloatingActions';

interface PostHTMLProps {
  html: string;
  isGatedContentDisabled: boolean;
  subscription?: Subscription;
  admin?: Admin;
  post: Post;
  publication: Record<string, any>;
}

const PostHTML = ({ html, isGatedContentDisabled, subscription, admin, post, publication }: PostHTMLProps) => {
  const breadCrumbs = [
    {
      text: publication?.name,
      href: '../',
    },
    {
      text: 'Posts',
      href: undefined,
    },
    {
      text: post.web_title,
      href: post.slug,
    },
  ];

  const postPadding = publication.web_template.post_padding;

  return (
    <>
      <div className="relative mx-auto max-w-6xl px-4">
        <FloatingActions
          post={post}
          subscription={subscription}
          admin={admin}
          isGatedContentDisabled={isGatedContentDisabled}
        />
        <div className="">
          <div className="mx-auto flex max-w-2xl flex-col pb-4">
            {publication.render_breadcrumbs && (
              <PostPaddingContainer postPadding={postPadding} classNames="mt-8">
                <Breadcrumbs breadcrumbs={breadCrumbs} />
              </PostPaddingContainer>
            )}

            <TransformedHtml html={html} slug={post.slug} update={isGatedContentDisabled} />
          </div>
        </div>
      </div>
    </>
  );
};

export default PostHTML;
